var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.$route.query.search)?[_c('OrderTable',{attrs:{"search":true}})]:[_c('OrderTable',{attrs:{"openFlight":_vm.flightId}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }